import React from "react";
var __jsx = React.createElement;
import stl from "./AuthFormV2.module.css";
import checkboxStl from "@/common/HOCs/rhf/checkbox/RHFCheckbox.module.css";
import useDirection from "@hooks/useDirection";
import { useTranslation } from "@i18n";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import { useModal } from "@componentsShared/BottomSheet";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import { CDN_LINK } from "@globalConfig";
var AuthFormV2 = function AuthFormV2(_ref) {
  var _validationError$extr;
  var external_links = _ref.external_links,
    handleFieldsChange = _ref.handleFieldsChange,
    fields = _ref.fields,
    validationError = _ref.validationError,
    loading = _ref.loading,
    onSubmit = _ref.onSubmit,
    generalError = _ref.generalError,
    authScreenDesign = _ref.authScreenDesign,
    whatsappOptin = _ref.whatsappOptin,
    onWhatsappOptinChange = _ref.onWhatsappOptinChange;
  var dir = useDirection();
  var _useTranslation = useTranslation(["web_auth"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _ref2 = useModal() || {},
    goToScreenByKey = _ref2.goToScreenByKey;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.formWrapper
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit,
    className: stl.form
  }, /*#__PURE__*/React.createElement("strong", null, authScreenDesign.title), /*#__PURE__*/React.createElement("p", {
    className: "".concat(stl.subTitle, " ").concat(generalError ? stl.hasError : "")
  }, authScreenDesign.description), generalError && /*#__PURE__*/React.createElement("p", {
    className: stl.error
  }, generalError), /*#__PURE__*/React.createElement(InputPhoneNumber, {
    id: "login-phone-input",
    className: stl.mb20,
    defaultValue: fields.phone_number,
    onChange: function onChange(value) {
      // Create a synthetic event to match the signature expected by handleFieldsChange
      var syntheticEvent = {
        target: {
          name: "phone_number",
          value: value
        }
      };
      handleFieldsChange("phone_number")(syntheticEvent);
    },
    errorLabel: (_validationError$extr = validationError.extractErrorMessageFrom(["phone_number"])) !== null && _validationError$extr !== void 0 ? _validationError$extr : ""
  }), /*#__PURE__*/React.createElement("label", {
    className: "w-full flex items-center mt-2 mb-4 cursor-pointer [&>*]:mx-[3px] [&>img]:w-6 [&>span]:text-[#6c7a8d] [&>span]:text-xs [&>span]:leading-6"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    className: checkboxStl.checkbox,
    type: "checkbox",
    checked: whatsappOptin,
    onChange: function onChange(e) {
      return onWhatsappOptinChange(e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: checkboxStl.boxDummy
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whatsapp",
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React.createElement("span", null, tShort("whatsapp_optin_label", {
    ns: "web_auth"
  }))), /*#__PURE__*/React.createElement(SubmitButton, {
    id: "login-submit-btn",
    className: stl.btn,
    type: "submit",
    loading: loading,
    disabled: fields.phone_number.length < 10
  }, t("start", {
    ns: "web_auth"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.p, " ").concat(stl.font12, " ").concat(stl.grayText, " ").concat(stl.disclaimer)
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.initialStyle
  }, t("creating_account_agree", {
    ns: "web_auth"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    onClick: function onClick(e) {
      var _external_links$terms;
      e.preventDefault();
      if (external_links !== null && external_links !== void 0 && (_external_links$terms = external_links.termsLinkProps) !== null && _external_links$terms !== void 0 && _external_links$terms.onClick) {
        var _external_links$terms2;
        return external_links === null || external_links === void 0 ? void 0 : (_external_links$terms2 = external_links.termsLinkProps) === null || _external_links$terms2 === void 0 ? void 0 : _external_links$terms2.onClick();
      }
      goToScreenByKey("terms-landing");
    },
    className: [stl.link, stl.initialStyle].join(" ") + " cursor-pointer"
  }, t("terms_conditions_2", {
    ns: "web_auth"
  })), /*#__PURE__*/React.createElement("span", {
    className: [stl.initialStyle].join(" ")
  }, " ", t("and", {
    ns: "web_auth"
  })), " ", /*#__PURE__*/React.createElement("a", {
    onClick: function onClick(e) {
      var _external_links$priva;
      e.preventDefault();
      if (external_links !== null && external_links !== void 0 && (_external_links$priva = external_links.privacyPolicyLinkProps) !== null && _external_links$priva !== void 0 && _external_links$priva.onClick) {
        var _external_links$priva2;
        return external_links === null || external_links === void 0 ? void 0 : (_external_links$priva2 = external_links.privacyPolicyLinkProps) === null || _external_links$priva2 === void 0 ? void 0 : _external_links$priva2.onClick();
      }
      goToScreenByKey("privacy-policy");
    },
    className: [stl.link, stl.initialStyle].join(" ") + " cursor-pointer"
  }, t("privacy_policy", {
    ns: "web_auth"
  }))))));
};
export default AuthFormV2;